<script setup>
import { computed } from 'vue';

const props = defineProps({
  template: { type: Object, required: true },
});

const STATUS_CLASSES = {
  APPROVED: 'bg-n-teal-3 text-n-teal-11',
  PENDING: 'bg-n-amber-3 text-n-amber-11',
  REJECTED: 'bg-n-ruby-3 text-n-ruby-11',
};

const status = computed(() => (props.template.status || '').toUpperCase());
const badgeClass = computed(
  () => STATUS_CLASSES[status.value] || 'bg-n-alpha-2 text-n-slate-11'
);
const statusKey = computed(() =>
  STATUS_CLASSES[status.value]
    ? `CANNED_MGMT.WHATSAPP_TEMPLATES.STATUS.${status.value}`
    : null
);
const bodyText = computed(
  () =>
    (props.template.components || []).find(c => c.type === 'BODY')?.text || ''
);
// A Meta manda 'NONE' quando não houve rejeição; só interessa o motivo real.
const rejectedReason = computed(() => {
  const reason = props.template.rejected_reason;
  return reason && reason !== 'NONE' ? reason : null;
});
</script>

<template>
  <div
    class="flex items-start justify-between gap-3 px-4 py-3 border-b border-n-weak"
  >
    <div class="min-w-0">
      <div class="flex items-center gap-2">
        <p class="mb-0 font-medium text-n-slate-12">{{ template.name }}</p>
        <span class="text-xs text-n-slate-11">{{ template.language }}</span>
        <span class="text-xs text-n-slate-11">{{ template.category }}</span>
      </div>
      <p class="mb-0 text-sm truncate text-n-slate-11">{{ bodyText }}</p>
      <p
        v-if="status === 'REJECTED' && rejectedReason"
        class="mb-0 text-xs text-n-ruby-11"
      >
        {{ rejectedReason }}
      </p>
    </div>
    <span class="px-2 py-0.5 text-xs rounded-full shrink-0" :class="badgeClass">
      {{ statusKey ? $t(statusKey) : template.status }}
    </span>
  </div>
</template>
